import React, { Component } from 'react';

class Tool extends Component {

  state = {
    active: false
  };
  handlers = [];
  width = 0;
  height = 0;
  name = "";
  childTools = []


  constructor(props, width, height, name, stroke) {
    super(props);

    this.state = {
      active: this.props.active
    }

    this.toolbar = this.props.toolbar;

    this.stroke = stroke;

    this.width = width;
    this.height = height;
    this.name = name;
  }

  addChild(tool) {
    this.childTools.push(tool);
  }

  on(evt, handler) {
    if(!this.handlers[evt])
      this.handlers[evt] = [];
    this.handlers[evt].push(handler);
  }

  callEvent(evt, ...args) {
    if(this.handlers[evt])
      this.handlers[evt].forEach(h => h(...args));
  }

  setActive(active) {
    this.setState({
      active
    });
  }

  componentDidMount() {
    //console.log(this.name+':', this.refs, this.width, this.height)
    const el = this.refs[this.name];
    el.onclick = (e) => this.callEvent('click', e);
    this.onToolInit();
  }

  getCursor(url) {
    return (
      (url ? 'url("' : '') +
      "data:image/svg+xml;utf8,<svg fill='" + (this.stroke ? 'none' : 'black') + "' stroke='" + (this.stroke ? 'black' : 'none') + "' stroke-width='" + (this.stroke ? 4 : 1) + "' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='"+ this.width + "px' height='" + this.height + "px'>" + this.refs[this.name].innerHTML.replace(/"/g, "'") + "</svg>"
      + (url ? '"), auto' : '')
    );
  }

  setToolBar(tb) {
    this.toolbar = tb;
  }

  /*
  url("data:image/svg+xml,<svg fill='black' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='15px' height='20px'><polygon points='0,0 0,20 7,14 15,14' /></svg>"), auto;
   */

  render() {
    return (
      <div className="Tool">
        <svg fill={this.stroke ? 'none' : 'currentColor'} stroke={this.stroke ? 'currentColor' : 'none'} strokeWidth={this.stroke ? 4 : 1} width={this.width} height={this.height} ref={this.name} className={'tool' + (this.state.active ? " active": "")}>{this.renderTool()}</svg>
        {/* {this.renderList()} */}
      </div>
    )
  }

  renderTool() {}

  renderList() {
    if(this.childTools.length) {
      return (
        <div className="subToolList">
          <ul style={{listStyle: "none", padding: 0, margin: 0}}>
            {this.childTools.map((child, i) => {
              return <li key={i} style={{margin: "10px 0px"}}>{child}</li>
            })}
          </ul>
        </div>
      )
    }
    return null;
  }

  onToolInit() {}

}

export default Tool;



// WEBPACK FOOTER //
// ./src/components/ui/tools/Tool.js